"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const useTypographyStyle = ({ weight, size, secondColor }) => {
    const theme = (0, material_1.useTheme)();
    const main = Object.assign(Object.assign(Object.assign({}, (weight && { fontWeight: weight })), (size && { fontSize: size })), { color: secondColor ? theme.palette.primary.main : 'inherit' });
    return { main };
};
exports.default = useTypographyStyle;
